let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cJ79V")).then(() => parcelRequire('7rsxb'));